import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import { get_cookies, isLoggedIn } from "../../../components/Cookies/Cookies";
import { Redirect } from "react-router-dom";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
const PackageSalesCOMenu = props => {
	//ApiData Component Content Variables
	const x = 0;
	const [PackagesNavDetails, loadPackagesNav] = useState([]);
	const navigations = [];
    const selectedNavCode = props.match.params.nav_code ? props.match.params.nav_code : '';
	const selectedNavName = props.match.params.nav_name ? props.match.params.nav_name : '';
	//OnLoad Event/Data Fetching
	useEffect(() => {
		get_package_navigation();
	}, []);

	useEffect(() => {
		//
		isLoggedIn();
	}, [x]);

	//Api Functions SOF
    const get_package_navigation = async () => {
		await axios
			.get(process.env.REACT_APP_API_URL + "packagesnav_co_menu", {
				params: {
					nav_code: selectedNavCode,
					isInternational: get_cookies("branchdino") != "DAVAOHQ" ||get_cookies("branchdino") != "CEBUHQ" ?1:0
				}
			})
			.then(function (res) {
                loadPackagesNav(res.data.packagesnav_co_menu);
			})
			.catch(function (error) {
				// console.log(error);
			});
	};
	//Api Request Functions EOF
	return (
        !selectedNavCode ? <Redirect to="/sales" /> :
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
                <Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
                    <NavLink to="/package-sales-codesonly">
						<h2 className="header-title">Package Sales (Codes Only)</h2>
					</NavLink>
					<Typography color="textPrimary">{selectedNavName + " Codes Only"}</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<Grid container spacing={2}>
                    {PackagesNavDetails.map((value, index) => {
						// <option value={key}>{tifs[key]}</option>
						navigations.push(
							<Grid
								item
								xs={6}
								className="app-card-container"
								style={{
									"--cardBorderColor": value.nav_color
								}}
							>
								<NavLink
									to={
										"/package-sales-setpackage/" +
										value.id +
										"/" +
										value.nav_name
									}
								>
									<div className="app-card">
										{value.nav_name}
									</div>
								</NavLink>
							</Grid>
						);
					})}
					{navigations}
				</Grid>
			</div>
		</div>
	);
};

export default PackageSalesCOMenu;
